module.exports = __webpack_public_path__ + "img/luna nueva.d3817f30.svg";